import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Footer from "../components/biggest/Footer";
import ReservationContent from "../components/biggest/ReservationContent";
import { NotificationService } from "../services/Notification.service";
import { smoothScrollUp } from "../services/utils";
import { useStorePageManager } from "../store/PageManage";
import { useStoreUserManager } from "../store/UserManage";

export default function ProfileReservation() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleUpdateStorePage = useStorePageManager(
    (state) => state.handleUpdateStorePage
  );
  const handleUpdateDesactiveHeader = useStorePageManager(
    (state) => state.handleUpdateDesactiveHeader
  );
  const userData = useStoreUserManager((state) => state.user);
  useEffect(() => {
    handleUpdateStorePage(false);
    handleUpdateDesactiveHeader(false);
  }, []);
  useEffect(() => {
    let newTimeout = setTimeout(() => {
      smoothScrollUp(true);
    }, 100);
    return () => {
      clearTimeout(newTimeout);
    };
  }, []);
  useEffect(() => {
    if (!userData) return;
    if (userData.connected == false) {
      navigate("/");
      NotificationService.addToQueue(
        1,
        t("profileReservation.notification.youNeedConnectTxt")
      );
    }
  }, [userData]);
  return (
    <>
      <main>
        <ReservationContent />
        <Footer />
      </main>
    </>
  );
}
